import { TextField, useColorScheme } from "@mui/material";

interface EmailInputProps {
  email: string,
  setEmail: React.Dispatch<React.SetStateAction<string>>
}

export default function EmailInput({ email, setEmail }: EmailInputProps) {
  const { mode, systemMode } = useColorScheme();

  return (
    <TextField
      id="email"
      type="email"
      name="email"
      placeholder="seu@email.com"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      autoComplete="email"
      // autoFocus
      fullWidth
      variant="outlined"
      label="Email"
      sx={{
        ...((mode === 'dark' || systemMode === 'dark') ? {
          '& .MuiOutlinedInput-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #050f02ff inset !important',
          },
        } : {
          '& .MuiOutlinedInput-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #ffffff inset !important',
          },
        }),
        '& .MuiOutlinedInput-input': {
          // padding: '10px',
        },
      }}
    />
  )
}